import { AuthService } from "./auth-service";

const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require("axios").default;

export class HomePageService {
  // PUT: The PUT method replaces all current representations of the target resource with the request payload.
  // PATCH: The PATCH method is used to apply partial modifications to a resource.

  static async getList(params) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/homepage/`;
      const response = await axios.get(base_url, {
        params: params,
        headers: {
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response.data;
    } catch (error) {
      console.error(error);
      return error.response;
      //throw error;
    }
  }

  static async update(id, data) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/homepage/`;
      const response = await axios.put(`${base_url}${id}/`, data, {
        headers: {
          //'Content-Type': 'multipart/form-data',
          Authorization: `Token ${AuthService.getWpProxyToken()}`,
        },
      });
      //console.log(response);
      return response;
    } catch (error) {
      console.error(error.response.data);
      return error.response;
    }
  }

  static async updateWidgetPreview(id, widgets) {
    try {
      const base_url = `${REACT_APP_DOMAIN}/api/homepage/`;
      const response = await axios.patch(
        `${base_url}${id}/`,
        { widget_preview: widgets },
        {
          headers: {
            //'Content-Type': 'multipart/form-data',
            Authorization: `Token ${AuthService.getWpProxyToken()}`,
          },
        }
      );
      //console.log(response);
      return response;
    } catch (error) {
      console.error(error.response.data);
      return error.response;
    }
  }
}
